import { appColors, HighlightableText, Tier } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerPathDiagram } from '@backrs_ui/grow-ui/src/components/CareerPathDiagram/CareerPathDiagram';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { ResultsPill } from './ResultsPill';
import { RESULT_PAGE_TOUR_IDS } from '../tour/ResultPage.tour';

const MINIMUM_TRACK_STRINGS = appStrings.modules.results;

type MinimumTrackExplanationProps = Readonly<{
  minimumTrack: Tier;
  entrepreneurshipRecommended: boolean;
}>;

export const MinimumTrackExplanation = ({
  minimumTrack,
  entrepreneurshipRecommended,
}: MinimumTrackExplanationProps) => {
  const { aspirationsIndicate, description, entrepreneurshipText } =
    MINIMUM_TRACK_STRINGS[minimumTrack];

  return (
    <Box sx={minimumTrackExplanationStyle} id={RESULT_PAGE_TOUR_IDS.step2}>
      <Box mb={3}>
        <ResultsPill title={MINIMUM_TRACK_STRINGS.minTrackExplanationHeader} />
        <Box sx={aspirationAndCareerPathStyle}>
          <Typography variant="body1" sx={aspirationsIndicateTextStyle}>
            {aspirationsIndicate}
          </Typography>
          <Box sx={careerPathDiagramContainerStyle}>
            <CareerPathDiagram
              minimumTrack={minimumTrack}
              entrepreneurshipRecommended={entrepreneurshipRecommended}
            />
          </Box>
        </Box>
      </Box>
      <HighlightableText
        text={`${description}${entrepreneurshipRecommended ? entrepreneurshipText : ''}`}
        style={{
          marginTop: 2,
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
          columnCount: 2,
          columnGap: '2rem',
          '@media (max-width: 796px)': {
            columnCount: 1,
            overflowWrap: 'normal',
          },
        }}
      />
    </Box>
  );
};

const aspirationAndCareerPathStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  mt: 2,
};

const aspirationsIndicateTextStyle: SxProps<Theme> = {
  width: '43%',
  fontStyle: 'italic',
  fontSize: '14px',
  lineHeight: '1.25',
  alignSelf: 'flex-start',
  '@media (max-width: 1200px)': {
    width: '100%',
    mb: 3,
  },
};

const careerPathDiagramContainerStyle: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  justifySelf: 'flex-end',
  alignSelf: 'flex-end',
  '@media (max-width: 1200px)': {
    width: '100%',
  },
};

const minimumTrackExplanationStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: `2px solid ${appColors.neutral.black}`,
  borderRadius: '.5rem',
  paddingX: {
    xs: '1rem',
    sm: '2rem',
  },
  paddingY: '2rem',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
};
